module.exports = __webpack_public_path__ + "static/box-3aab915b39cdc9656bf437b61df0c556.png";